<template>
  <div class="main-content">
    <section class="section">
      <!-- Breadcrumb -->
      <PageHeaderNoAction/>
      <div class="section-body">
        
        <DataFilter :gridId="gridId" :isExport="false" :hasNew="false"></DataFilter>
        <SlickGrid :gridId="gridId" :editable="false" :frozenColumn="2" :isAutoInitData="true" baseUrl="/userBuildForm"/>
      </div>
    </section>
  </div>
</template>


<script>
import api from "@/api";
import { mapActions, mapGetters } from "vuex";

export default {
  title: "Form List",
  access_code: "F_LIST01",
  icon: "far fa-copy fa-fw",
  components: {},
  order:5,
  data() {
    return {
      gridId: "list03",
      formData: {
        staff_name: ""
      }
    };
  },
  created() {
  },
  computed: {
    ...mapGetters("grid", ["getGridById"]),

    grid() {
      return _.cloneDeep(this.getGridById(this.gridId));
    }
  },
  mounted() {},
  methods: {
    ...mapActions("grid", ["actionResetGrid", "actionSetGrid", "actionRequest"])
  }
};
</script>

<style scoped>
.section-body{
  padding-top:100px
}
</style>